import getMixedFileType from 'utils/getMixedFileType'

export default function getCurrentFileTypes({ state }) {
  const currentFiles = state.get('media.files')

  let fileTypes = Object.keys(currentFiles).reduce((acc, fileKey) => {
    let extension = getMixedFileType(currentFiles[fileKey].extension)
    let fileCount = acc[extension] ? acc[extension].count + 1 : 1

    acc[extension] = {
      label: extension.toUpperCase() + ' (' + fileCount + ')',
      type: extension,
      count: fileCount,
      selected: true
    }

    return acc
  }, {})

  state.set('media.filter.fileTypes', fileTypes)
  state.set('media.filter.active', false)
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/getCurrentFileTypes.js